import { render } from "./AccountContextWrapper.vue?vue&type=template&id=72347a52"
import script from "./AccountContextWrapper.vue?vue&type=script&lang=js"
export * from "./AccountContextWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__